import { EmptyProgramScreen } from '@/components/NotEligibleScreen';

export default function EmptyProgram() {
  return <EmptyProgramScreen />;
}
